
import { connect } from 'react-redux';

import { resetThunk } from './resetThunk';
import { decodeThunk } from './decodeThunk';
//import { shareThunk } from './shareThunk';

import Result from './Result';

const formatDate = (date) => {
    if ( date < 10 ) {
        return '0' + String(date);
    }
    return String(date);
}

const formatYear = (date) => {
    if ( date < 10 ) {
        return '000' + String(date);
    }
    if ( date < 100 ) {
        return '00' + String(date);
    }
    if ( date < 1000 ) {
        return '0' + String(date);
    }
    return String(date);
}

let mapStateToProps = (state, ownProps) => ({
    routeName: state.router.routeName,

    birthDayInput: formatDate(state.user.birthDay),
    birthMonthInput: formatDate(state.user.birthMonth),
    birthYearInput: formatYear(state.user.birthYear),

    arkanes: state.user.arkanes,
    innerArkanes: state.user.innerArkanes,
    soulAge: state.user.soulAge,
    innerChild: state.user.innerChild,
    longKarma: state.user.longKarma,
    genderArkanes: state.user.genderArkanes,
    energyArkanes: state.user.energyArkanes,
    digitsCount: state.user.digitsCount,
    maleIsFlipped: state.user.maleIsFlipped,
    femaleIsFlipped: state.user.femaleIsFlipped,
});

let mapDispatchToProps = (dispatch) => ({
    onReset: () => {
        dispatch(resetThunk());
    },
    onShare: () => {
        //dispatch(shareThunk());
    },
    onDecode: () => {
        dispatch(decodeThunk());
    },
});

const ResultContainer = connect(mapStateToProps, mapDispatchToProps)(Result);

export default ResultContainer;
